const TrainigStatuses = [
  { id: 'created', name: 'En attente' },
  { id: 'opened_for_registration', name: 'Ouvert aux inscriptions' },
  { id: 'closed_for_registration', name: 'Fermé aux inscriptions' },
  { id: 'canceled', name: 'Annulé' },
];

export default TrainigStatuses;
